<template>
<mdb-container>
   <LoadBannerReport/>
</mdb-container>
</template>

<script>
import {
  mdbContainer,
} from "mdbvue";
import LoadBannerReport from "../components/LoadBannerReport.vue";


export default {
name: "Banners",
components: {
    mdbContainer,
    LoadBannerReport
}
}
</script>
